// extracted by mini-css-extract-plugin
module.exports =  {"list":"AejlXYI","icon-container":"dzKHkVd","iconContainer":"dzKHkVd","label":"NyLf1QK","item":"Bylj7mO"};